import React, { useContext } from 'react'
import { CurrentUILocaleContext } from 'marketing-site/src/library/utils'
import { IProps } from './index'

export const CloseButton = ({ onClick }: IProps) => {
  const { ui } = useContext(CurrentUILocaleContext)

  return (
    <button
      className="close-button"
      onClick={onClick}
      type="button"
      aria-label={ui.localize('CloseButton.ariaCloseButtonLabel')}
    >
      <svg
        className="close-button__icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M2.337 20.337a.937.937 0 1 0 1.326 1.326L12 13.326l8.337 8.337a.937.937 0 0 0 1.326-1.326L13.326 12l8.337-8.337a.938.938 0 0 0-1.326-1.326L12 10.674 3.663 2.337a.937.937 0 1 0-1.326 1.326L10.674 12l-8.337 8.337Z"
          clipRule="evenodd"
        />
      </svg>
      <style jsx>
        {`
          .close-button {
            cursor: pointer;
            user-select: none;
            display: block;
            outline: none;

            &__icon {
              fill: currentColor;
              vertical-align: middle; // Removes white space below.
            }

            &:focus .close-button__icon {
              outline: 1px dotted currentColor;
              outline-offset: 3px;
            }
          }
        `}
      </style>
    </button>
  )
}
